/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { put } from 'redux-saga/effects'

import _ from 'lodash'

import { updateToken } from 'Redux/actions/auth'

function* onTokenRehydrateSuccess(action) {
  try {
    const refreshToken = _.get(action, 'payload.data.RefreshToken', null)

    if (refreshToken) {
      yield put(updateToken(refreshToken))
    }

    yield true
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err)
  }
}

export default onTokenRehydrateSuccess
